import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const galerieItems = [
  { href: "/fotogalerie-svatby-desktop", img: "./img/img-svatby.jpg", title: "SVATBY" },
  { href: "/fotogalerie-wellness", img: "./img/wellness/wellness-uvodni.jpg", title: "WELLNESS & SPA" },
  { href: "/fotogalerie-pokoje", img: "./img/img-pokoje.jpg", title: "UBYTOVÁNÍ" },
  { href: "/fotogalerie-exterier", img: "./img/img-exterier.jpg", title: "EXTERIÉR" },
  { href: "/fotogalerie-restaurace", img: "./img/img-interier.jpg", title: "INTERIÉR" },
  { href: "/fotogalerie-sladky-bar", img: "./img/img-sladky-bar.jpg", title: "SLADKÝ BAR" },
  { href: "/fotogalerie-rauty", img: "./img/img-rauty.jpg", title: "RAUTY" },
  { href: "/fotogalerie-akce-duo-jamaha", img: "./img/img-akce-duo-jamaha.jpg", title: "AKCE DUO JAMAHA" },
  { href: "/fotogalerie-speciality", img: "./img/img-nase-speciality.jpg", title: "NAŠE SPECIALITY" },
];

const Galerie: React.FC = () => {
  return (
    <>
      {/* ================= HEAD ================= */}
      <Helmet>
        <title>Galerie | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Prohlédněte si naši fotogalerii – atmosféra, akce, jídla i interiér hospůdky."
        />
      </Helmet>

      {/* ================= NAVBAR – IZOLACE ================= */}
      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      {/* ================= OBSAH ================= */}
      <main className="bg-[#F5E7CC] text-[#32180d] overflow-x-hidden">

        {/* ================= HERO ================= */}
        <section className="bg-white py-20 text-center">
          <h1 className="text-3xl md:text-4xl font-bold font-serif">
            FOTOGALERIE
          </h1>
        </section>

        {/* ================= GALERIE GRID ================= */}
        <section className="max-w-7xl mx-auto px-6 py-20">

          <div
            className="
              grid
              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-3
              gap-8
            "
          >
            {galerieItems.map((item, i) => (
              <Link
                key={i}
                to={item.href}
                className="group block no-underline"
              >
                <div className="overflow-hidden rounded-lg shadow-md bg-white">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="
                      w-full
                      h-56
                      object-cover
                      transition-transform
                      duration-300
                      group-hover:scale-105
                    "
                  />
                  <div
                    className="
                      py-4
                      text-center
                      font-serif
                      font-bold
                      text-lg
                      bg-white
                    "
                  >
                    {item.title}
                  </div>
                </div>
              </Link>
            ))}
          </div>

        </section>

        {/* ================= FOOTER – ABSOLUTNÍ RESET ================= */}
        <div className="[all:unset] block">
          <Footer />
        </div>

      </main>
    </>
  );
};

export default Galerie;
